import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useSite } from "@/lib/site";
import { Reveal, Kicker } from "./Reveal";

export const About = () => {
  const { t } = useSite();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="nosotros" ref={ref} className="relative overflow-hidden py-24 lg:py-36" data-testid="about-section">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <Kicker>{t.about.kicker}</Kicker>
            <h2 className="mt-4 font-display text-4xl font-black tracking-tighter sm:text-5xl">{t.about.title}</h2>
            <p className="mt-6 text-base leading-relaxed text-[var(--muted)] md:text-lg" data-testid="about-body">{t.about.body}</p>
          </Reveal>
          <Reveal delay={0.15} className="relative mt-10">
            <div className="relative aspect-[4/3] overflow-hidden rounded-[2rem] border border-[var(--line)] bg-black" style={{ clipPath: "inset(0 round 2rem)" }}>
              <motion.img style={{ y, scale: 1.18 }} src="/brand/logo.png" alt="Resilience Brothers" className="h-full w-full object-cover" />
              <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_45%,transparent_35%,rgba(10,10,15,0.85)_100%)]" />
            </div>
          </Reveal>
        </div>
        <div className="grid content-center gap-5 sm:grid-cols-2 lg:col-span-7">
          {t.about.pillars.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={p.title} delay={i * 0.08} className={i % 2 ? "sm:mt-10" : ""}>
                <div className="rb-card group h-full rounded-3xl p-7 hover:-translate-y-0.5" data-testid={`pillar-${i}`}>
                  <span className="font-mono text-xs text-[var(--faint)]">0{i + 1}</span>
                  <Icon className="mt-6 h-7 w-7 text-[var(--violet-h)] transition-transform duration-500 group-hover:scale-110" />
                  <h3 className="mt-5 font-display text-xl font-extrabold">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-[var(--muted)]">{p.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
